// ─── Fiche d'une recette — LECTURE SEULE (règle app-wide) ─────────
// Clic sur une recette = cette fiche (jamais l'édition directe). ✏️, 🛒 et 🗑️
// dans l'en-tête. Le swipe sur la carte reste un raccourci direct.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, HIT, useUI, useT } from '@mop/core';
import { coutRecette } from './services/recettes';

export default function FicheRecette({ visible, recette, categorie, onFermer, onEditer, onSupprimer, onAjouterListe }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  if (!visible || !recette) return null;

  const cout = coutRecette(recette);
  const ingredients = recette.ingredients || [];
  const etapes = recette.etapes || [];

  return (
    <Feuille visible titre={recette.nom || t('repas.sansNom')} emoji={categorie?.emoji || '🍽️'} onFermer={onFermer}
      boutons={(
        <>
          {/* 🛒 ouvre la feuille d'ajout, rendue au niveau de l'ÉCRAN : deux
              <Modal> natives imbriquées figent l'app. */}
          <TouchableOpacity onPress={onAjouterListe} hitSlop={HIT} accessibilityLabel={t('courses.ajouterALaListe')}>
            <Text style={s.hIc}>🛒</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onEditer} hitSlop={HIT} accessibilityLabel={t('commun.editer')}>
            <Text style={s.hIc}>✏️</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onSupprimer} hitSlop={HIT} accessibilityLabel={t('commun.supprimer')}>
            <Text style={[s.hIc, { color: UI.danger }]}>🗑️</Text>
          </TouchableOpacity>
        </>
      )}>

      <View style={s.entete}>
        <Text style={s.sous}>
          {categorie?.label ? `${categorie.emoji} ${categorie.label}  ·  ` : ''}
          {t('repas.portions')} : {recette.portions}
          {recette.tempsMin ? `  ·  ${t('repas.nMin', { n: recette.tempsMin })}` : ''}
        </Text>
        {cout > 0 && <Text style={s.cout}>{cout.toFixed(2)} €</Text>}
      </View>

      <Text style={s.sect}>{t('repas.ingredients')}</Text>
      {ingredients.length === 0 ? <Text style={s.vide}>—</Text> : ingredients.map((i, idx) => (
        <Text key={idx} style={s.ligne}>• {[i.quantite, i.unite, i.nom].filter(Boolean).join(' ')}</Text>
      ))}

      <Text style={s.sect}>{t('repas.preparation')}</Text>
      {etapes.length === 0 ? <Text style={s.vide}>—</Text> : etapes.map((e, idx) => (
        <Text key={idx} style={s.ligne}>{idx + 1}. {e}</Text>
      ))}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  hIc: { fontSize: 18, color: UI.accent },
  entete: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 },
  sous: { flex: 1, fontSize: 13.5, color: UI.muted },
  cout: { fontSize: 15, fontWeight: '800', color: UI.ink },
  sect: { fontSize: 12, fontWeight: '800', color: UI.accent, textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 16, marginBottom: 8 },
  ligne: { fontSize: 14.5, color: UI.ink, marginBottom: 6, lineHeight: 20 },
  vide: { fontSize: 13, color: UI.faint },
});
